import { render, staticRenderFns } from "./BlogEntriesTableAdmin.vue?vue&type=template&id=528dde4a&scoped=true"
import script from "./BlogEntriesTableAdmin.vue?vue&type=script&lang=ts"
export * from "./BlogEntriesTableAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BlogEntriesTableAdmin.vue?vue&type=style&index=0&id=528dde4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528dde4a",
  null
  
)

export default component.exports